import React, { useEffect, useState } from "react";
import { portalApi } from "@/lib/portalApi";

export default function PortalCampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [lists, setLists] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [mailingListId, setMailingListId] = useState("");
  const [templateId, setTemplateId] = useState("");
  const [subject, setSubject] = useState("");
  const [htmlBody, setHtmlBody] = useState("<p>Campaign body</p>");
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const [c, l, t] = await Promise.all([
      portalApi.campaigns.index(),
      portalApi.lists.index(),
      portalApi.templates.index(),
    ]);
    setCampaigns(c.campaigns);
    setLists(l.mailing_lists);
    setTemplates(t.email_templates);
  };

  useEffect(() => {
    load().catch((err) => setError(err.message));
  }, []);

  async function onTemplateChange(id) {
    setTemplateId(id);
    if (!id) return;
    try {
      const data = await portalApi.templates.show(id);
      setSubject(data.email_template.subject);
      setHtmlBody(data.email_template.html_body);
    } catch (err) {
      setError(err.message);
    }
  }

  async function onCreate(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    setOk("");
    try {
      await portalApi.campaigns.create({
        mailing_list_id: Number(mailingListId),
        email_template_id: templateId ? Number(templateId) : null,
        subject,
        html_body: htmlBody,
      });
      setOk("Draft campaign saved.");
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function onSend(id) {
    if (!window.confirm("Send this campaign to the list now?")) return;
    setError("");
    setOk("");
    try {
      await portalApi.campaigns.send(id);
      setOk("Campaign queued for delivery.");
      await load();
    } catch (err) {
      setError(err.message);
    }
  }

  async function onDelete(id) {
    if (!window.confirm("Delete this draft?")) return;
    try {
      await portalApi.campaigns.destroy(id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <>
      <h1>Campaigns</h1>
      <p className="muted">Compose and send via your SMTP settings</p>
      {error && <div className="portal-alert portal-alert--error">{error}</div>}
      {ok && <div className="portal-alert portal-alert--ok">{ok}</div>}

      <div className="portal-card">
        <h2>New draft</h2>
        <form className="portal-form" onSubmit={onCreate}>
          <label>
            Mailing list
            <select required value={mailingListId} onChange={(e) => setMailingListId(e.target.value)}>
              <option value="">Select list…</option>
              {lists.map((l) => (
                <option key={l.id} value={l.id}>
                  {l.name} ({l.subscriber_count})
                </option>
              ))}
            </select>
          </label>
          <label>
            Template (optional)
            <select value={templateId} onChange={(e) => onTemplateChange(e.target.value)}>
              <option value="">None</option>
              {templates.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </label>
          <label>
            Subject
            <input required value={subject} onChange={(e) => setSubject(e.target.value)} />
          </label>
          <label>
            HTML body
            <textarea required value={htmlBody} onChange={(e) => setHtmlBody(e.target.value)} style={{ minHeight: 200 }} />
          </label>
          <iframe className="portal-preview" title="Campaign preview" sandbox="" srcDoc={htmlBody} />
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Saving…" : "Save draft"}
          </button>
        </form>
      </div>

      <div className="portal-card">
        <h2>All campaigns</h2>
        {campaigns.length === 0 ? (
          <p className="muted">No campaigns yet.</p>
        ) : (
          <table className="portal-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>List</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {campaigns.map((c) => (
                <tr key={c.id}>
                  <td>{c.subject}</td>
                  <td>{c.mailing_list_name}</td>
                  <td>{c.status}</td>
                  <td className="portal-actions">
                    {c.status === "draft" && (
                      <>
                        <button type="button" className="btn" onClick={() => onSend(c.id)}>
                          Send
                        </button>
                        <button type="button" className="btn btn--ghost" onClick={() => onDelete(c.id)}>
                          Delete
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
